export default "__VITE_ASSET__BDSSEtr5__"